const BRAND_THEME_VARS = [
  '--theme-color-1',
  '--ds-theme-action-primary',
  '--ds-theme-action-primary-light',
  '--ds-theme-action-primary-gradient',
  '--ds-theme-loader-arc',
  '--ds-theme-loader-track-fill',
  '--ds-accordion-accent',
  '--ds-color-interactive-focus-ring',
  '--ds-accordion-border-active',
  '--ds-accordion-header-active-bg',
  '--ds-button-primary-bg',
  '--ds-button-primary-hover',
  '--ds-button-primary-active',
];

/**
 * Client Connect v2 scopes brand tokens on a container; portaled pickers mount on
 * document.body and would otherwise keep the default DS accent. Copy inline theme
 * vars from the nearest themed ancestor onto the overlay.
 */
export function getThemeStyleFromAnchor(anchorEl) {
  if (!anchorEl || typeof window === 'undefined') {
    return undefined;
  }

  let node = anchorEl;
  while (node && node !== document.documentElement) {
    const inlineStyle = node.style;
    const hasBrandPrimary = inlineStyle?.getPropertyValue?.('--ds-theme-action-primary')?.trim();
    if (hasBrandPrimary) {
      const themeStyle = {};
      BRAND_THEME_VARS.forEach((name) => {
        const value = inlineStyle.getPropertyValue(name).trim();
        if (value) {
          themeStyle[name] = value;
        }
      });
      return themeStyle;
    }
    node = node.parentElement;
  }

  return undefined;
}
